export default "__VITE_ASSET__Dn8fmmDs__"